import React, { useState } from 'react'
import styles from './ReportRow.module.scss'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import ArrowMenu from 'components/ContentBox/Global/ActionMenu/ActionMenu'

const ReportRow = ({ config, menu, action }) => {
  const [isRowOpen, setIsRowOpen] = useState(false)

  const handleToggle = () => setIsRowOpen((prevState) => !prevState)

  const rowOpenStyle =
    config.openedContent.length > 3
      ? { justifyContent: 'space-between' }
      : { gap: '57px' }

  return (
    <>
      <div className={`${styles.row} ${isRowOpen ? styles.rowOpenStyle : ''} `}>
        {config.mainFields.map((field, index) => (
          <div
            key={index}
            className={`${styles[`subRow${index + 1}`]} ${
              field.red ? styles.rowRed : ''
            }`}
          >
            {field.value}
          </div>
        ))}
        <div className={styles.btns}>
          <ArrowMenu variant='simple' onSimpleAction={handleToggle} />
          {menu && action && <ActionMenu menu={menu} action={action} />}
        </div>
      </div>

      {isRowOpen && (
        <div className={styles.rowOpen} style={rowOpenStyle}>
          {config.openedContent.map((el, index) => (
            <div className={styles.rowOpenItem} key={index}>
              <div className={styles.rowOpenHeader}>{el.header}</div>
              <div
                className={`${styles.rowOpenContent} ${
                  el.red ? styles.rowOpenRed : ''
                }`}
              >
                {el.content}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default ReportRow
